function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m2.075.822a2.074 2.074 0 0 0 -2.075 2.078v8.533a1.757 1.757 0 0 0 1.756 1.75h10.488a1.748 1.748 0 0 0 1.756-1.754v-8.529a2.074 2.074 0 0 0 -2.073-2.075zm10.167 9.468a1.206 1.206 0 0 1 -1.207 1.21h-8.07a1.206 1.206 0 0 1 -1.207-1.21v-4.255a1.206 1.206 0 0 1 1.207-1.207h8.07a1.206 1.206 0 0 1 1.207 1.207z",
  fill: "currentColor",
  fillRule: "evenodd"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/laptop-filled.83ea879b.svg";
export { SvgComponent as ReactComponent };